module.exports = __webpack_public_path__ + "img/judys-logo-2.2716ff7c.png";